import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostBinding,
} from "@angular/core";
import { AplicativosService } from "../services/aplicativos.service";

@Directive({
  selector: ".auth-pages",
})
export class AuthPagesDirective implements AfterViewInit {
  constructor(
    public aplicativosService: AplicativosService,
    public elementRef: ElementRef<HTMLElement>
  ) {
    this.aplicativosService.clearItem();
    this.aplicativosService.clearTheme();
  }

  ngAfterViewInit() {
    if (this.aplicativosService.appType === "ipe-saude" || this.aplicativosService.appType === "paz-e-bem" || this.aplicativosService.appType === "prefeitura" || this.aplicativosService.appType === "caxias-do-sul") {
      const logosWrapper = document.createElement("div");
      logosWrapper.classList.add("logos-wrapper");

      const logoSergioLovato = document.createElement("img");
      logoSergioLovato.src = '/assets/imgs/sergio-lovato.png'
      logoSergioLovato.classList.add("sergio-lovato");

      const logoIpe = document.createElement("img");
      logoIpe.src = '/assets/imgs/ipe.png'
      logoIpe.classList.add("ipe-saude");

      const logoEasy = document.createElement("img");
      logoEasy.src = '/assets/imgs/logo-easy-sem-corporate.png'
      logoEasy.classList.add("prefeitura");

      // logosWrapper.append(logoSergioLovato);
      
      if(this.aplicativosService.appType === "paz-e-bem" || this.aplicativosService.appType === "prefeitura" || this.aplicativosService.appType === "caxias-do-sul"){
        logosWrapper.append(logoEasy);  
      }

      if(this.aplicativosService.appType === "ipe-saude"){
        logosWrapper.append(logoIpe);
      }
      this.elementRef.nativeElement.append(logosWrapper);
    }

  }

  @HostBinding("class.auth-pages-paz-e-bem") get appTypePazEBem() {
    return this.aplicativosService.appType === "paz-e-bem";
  }

  @HostBinding("class.auth-pages-prefeitura") get appTypePrefeitura() {
    return this.aplicativosService.appType === "prefeitura";
  }
  
  @HostBinding("class.auth-pages-caxias-do-sul") get appTypeCaxiasDoSul() {
    return this.aplicativosService.appType === "caxias-do-sul";
  }
  
  @HostBinding("class.auth-pages-mundo-verde") get appTypeMundoVerde() {
    return this.aplicativosService.appType === "mundo-verde";
  }

  @HostBinding("class.auth-pages-ipe-saude") get appTypeIpeSaude() {
    return this.aplicativosService.appType === "ipe-saude";
  }
  @HostBinding("class.auth-pages-personal") get appTypePersonal() {
    return this.aplicativosService.appType === "personal";
  }
  @HostBinding("class.AuthPagesDirective") directiveHint = true;
}
